export interface ArtistNavigationProps {
    onSelect: (section: string) => void;
}

const ArtistNavigationBar: React.FC<ArtistNavigationProps> = ({ onSelect }) => {
    const sections: ReadonlyArray<string> = ["Home", 
        "Flash Store", 
        "Portfolio", 
        "Styles",
        "About", 
        "Reviews", 
        "Tours"];

    return (
        <header className="border-b border-gray-200 bg-white">
            <div className="mx-auto max-w-6xl px-4 py-3 flex items-center justify-between gap-4">
                <div className="flex items-center gap-6">
                    <nav className="hidden sm:flex items-center gap-3" aria-label="Primary">
                        {sections.map((section) => (
                            <button
                                key={section}
                                id={section}
                                onClick={() => onSelect(section)}
                                className="text-sm text-gray-700 hover:text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500 rounded px-1.5 py-0.5"
                            >
                                {section}
                            </button>
                        ))}
                    </nav>
                </div>
            </div>
        </header>
    );
};

export default ArtistNavigationBar;